import { render, staticRenderFns } from "./AssignamentNew.vue?vue&type=template&id=c5d0fdd2&scoped=true"
import script from "./AssignamentNew.vue?vue&type=script&lang=js"
export * from "./AssignamentNew.vue?vue&type=script&lang=js"
import style0 from "./AssignamentNew.vue?vue&type=style&index=0&id=c5d0fdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d0fdd2",
  null
  
)

export default component.exports